<ion-skeleton-text
  animated
  *ngIf="!conversation"
  style="width: 124px; height: 15px"
></ion-skeleton-text>
<div *ngIf="conversation">
  <span
    *ngIf="conversation.status === 'open'"
    class="status-label-needs-response"
  >
    <ion-icon name="custom-open"></ion-icon>
  </span>
  <span
    *ngIf="conversation.status === 'in_progress'"
    class="status-label-in-progress"
  >
    <ion-icon name="custom-in-progress"></ion-icon>
  </span>
  <span *ngIf="conversation.status === 'on_hold'" class="status-label-on-hold">
    <ion-icon name="custom-on-hold"></ion-icon>
  </span>
  <span *ngIf="conversation.status === 'closed'" class="status-label-closed">
    <ion-icon name="custom-closed"></ion-icon>
  </span>
  <a
    class="row-title row-link"
    [routerLink]="['/dashboard/inbox/all/conversations', conversation.id]"
    routerDirection="root"
  >
    {{ conversation.title }}
    <span class="opacity-50"> [#{{ conversation.friendlyId }}] </span>
  </a>
</div>
